<template>
  <div class="site-page">
    <intro></intro>
    <about></about>
    <shops></shops>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { startCase } from 'lodash';

import Intro from './Intro';
import About from './About';
import Shops from './Shops';

export default {
  components: {
    Intro,
    About,
    Shops
  },
  filters: {
    startCase: startCase
  },
  data() {
    return {
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ]
    };
  },
  methods: mapActions({
    fetchSettings: 'settings/fetchSettings',
    fetchStores: 'stores/fetchStores'
  }),
  created() {
    this.fetchSettings();
    this.fetchStores();
  }
};
</script>
